// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './polyfill'

require ('./apiConfig.js') // API CONFIG
require ('./shared/filters.js') // API CONFIG

// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router/index'
import componentsAutoload from './components-autoload'
import { store } from "./store/store-init"
import mobiscroll from '@mobiscroll/javascript'

mobiscroll.settings = { theme: 'ios', lang: 'es', touchUi: false }

// todo
// cssVars()

Vue.use(BootstrapVue)
Vue.use(componentsAutoload)

require('animate.css')

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
